import { cn } from "@/lib/utils";
import React from "react";
import { AppTopBar } from "./AppTopBar";

interface PageProps {
  children: React.ReactNode;
  document?: boolean;
  className?: string;
}

export const Page: React.FC<PageProps> = ({
  children,
  className,
  document,
}) => {
  return (
    <div
      className={cn(
        "flex h-full w-full flex-col overflow-auto",
        { "bg-background": document, "bg-background-1": !document },
        className,
      )}
    >
      <AppTopBar.BufferContainer />
      {children}
    </div>
  );
};
